function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 -18.4)"
}, React.createElement("g", {
  transform: "translate(0 18.4)"
}, React.createElement("path", {
  className: "a",
  d: "M22.772,25.16A8.111,8.111,0,0,0,7.744,22.465a4.646,4.646,0,0,0-.852-.081,4.445,4.445,0,0,0-4.439,4.439,4.853,4.853,0,0,0,.092.921A6.177,6.177,0,0,0,0,32.725,6.6,6.6,0,0,0,1.676,37.1,5.98,5.98,0,0,0,5.821,39.18h5a.777.777,0,0,0,0-1.555H5.89A4.9,4.9,0,0,1,1.555,32.72,4.615,4.615,0,0,1,3.84,28.747a.784.784,0,0,0,.34-.944,2.821,2.821,0,0,1-.173-.99,2.89,2.89,0,0,1,2.885-2.885,2.835,2.835,0,0,1,.985.173.781.781,0,0,0,.973-.4A6.556,6.556,0,0,1,21.3,25.862a.776.776,0,0,0,.645.691,5.6,5.6,0,0,1-.53,11.066H17.175a.777.777,0,1,0,0,1.555h4.33a6.889,6.889,0,0,0,4.618-2.28A7.166,7.166,0,0,0,22.772,25.16Z",
  transform: "translate(0 -18.4)"
}), React.createElement("path", {
  className: "a",
  d: "M167.781,190.847a.775.775,0,0,0,0-1.1l-4.117-4.117a.787.787,0,0,0-.547-.23.762.762,0,0,0-.547.23l-4.117,4.117a.78.78,0,0,0,.547,1.33.758.758,0,0,0,.547-.23l2.793-2.793v12.834a.777.777,0,1,0,1.555,0V188.054l2.793,2.793A.768.768,0,0,0,167.781,190.847Z",
  transform: "translate(-149.115 -175.785)"
})));

var SvgUpload = function SvgUpload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 28,
    height: 25.881,
    viewBox: "0 0 28 25.881",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUpload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/upload.91e3ab62.svg";
export { ForwardRef as ReactComponent };